// extracted by mini-css-extract-plugin
export default {"card":"Card_card__KnKXv","title":"Card_title__oJVfx","text":"Card_text__bw13H","position":"Card_position__l+rje"};